var _Rect, _Line, _Line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Line } from "react-native-svg";
var SvgPlusSquare = function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-plus-square"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  })), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  })), _Line2 || (_Line2 = /*#__PURE__*/React.createElement(Line, {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  })));
};
export default SvgPlusSquare;